





























































import Translations from '@/models/translations.model';
import ProductTileLayout from "./ProductTileLayout.vue";
import Icon from '@/models/icon.model';
import Product from '@/models/product.model';
import Config, { Mode } from '@/models/config.model';

export default {
  name: 'ProductTile',
  components: {
    ProductTileLayout,
  },
  props: {
    product: {
        type: Object,
        required: true,
    },
    productListingInstance: {
        type: Object,
        required: true,
    },
    productTileClass: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      instance: null,
      compareCheckboxHidden: true,
      compareCheckboxState: false,
      wishlistButtonState: false,
      detailLinktext: this.$store.state.translations.details,
    };
  },
  computed: {
    config(): Config {
      return this.$store.state.config;
    },
    isMatnoMode(): boolean {
      return this.config.mode === Mode.Matno;
    },
    isMatnoReducedMode(): boolean {
      return this.config.mode === Mode.MatnoReduced;
    },
    isFilterMode(): boolean {
      return this.config.mode === Mode.Filter;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    ecoIcon(): Icon | null {
      const { product }: { product: Product } = this;

      if (!product.icon || !product.icon.length) {
        return null;
      }

      for (let i = 0, iLen = product.icon.length; i < iLen; i++) {
        const currentIcon = product.icon[i]

        if (currentIcon.type === "eco") {
          return currentIcon;
        } 
      }

      return null;
    },
    detailLink(): string {
      const productName = this.product.label
        .replace(/[\[\]().,]/g, "") // remove square brackets, parantheses, dots and commas
        .replace(/[\s–/]/g, "-") // replace spaces, dashes and slashes with hyphens
        .replace(/-{2,}/g, "-") // replace multiple hyphens with a single hyphen
        .replace(/®|©/g, "") // replace Trademark and Copyright symbol
        .toLowerCase();

      return this.createDetailLink(productName);
    },
  },
  methods: {
    init(): void {
      this.instance = new this.productTileClass(this);
    },
    toggleWishlist(): void {
      this.instance.toggleWishlistButtonState();
    },
    toggleCompare(e: Event): void {
      const checkbox = e.currentTarget as HTMLInputElement;
      this.instance.toggleCompare(checkbox.checked);
    },
    setWishlistButtonState(wishlistButtonState: boolean): void {
      this.wishlistButtonState = wishlistButtonState;
    },
    setCompareCheckboxState(compareCheckboxState: boolean): void {
      this.compareCheckboxState = compareCheckboxState;
    },
    setCompareCheckboxHidden(compareCheckboxHidden: boolean): void {
      this.compareCheckboxHidden = compareCheckboxHidden;
    },
    createDetailLink(productName: string): string {
      const materials = this.$store.state.productsShop;
      
      if(materials && !this.isFilterMode) {
          const material = materials.filter((material: { matNo: any; }) =>  material.matNo ===  this.product.matNo);

          if(material.length === 0 ) {
            return this.translations.detailLink
              .replace("{MAT}", this.product.matNo)
              .replace("{NAME}", productName);
          }

          this.detailLinktext = this.$store.state.translations.shop;

          return this.translations.shopLink
            .replace(/{MAT}/g, material[0].matNo);
      }

      return this.translations.detailLink
        .replace("{MAT}", this.product.matNo)
        .replace("{NAME}", productName);
      
    }
  },
  mounted() {
    this.init();
  },
}
